/**
 * Edit Prompt controller - handles prompt editing business logic
 */

import * as promptLibraryService from '../../data/services/promptLibraryService';

/**
 * Update prompt fields
 * @param {string} promptId - The prompt ID
 * @param {Object} updates - Object with fields to update (title, description, promptText, backgroundTheory, categories)
 * @returns {Promise<Object>} Updated prompt
 */
export const updatePrompt = async (promptId, updates) => {
  // Prepare update data
  const updateData = {
    ...updates,
    updatedAt: new Date().toISOString(),
  };
  
  // Update prompt in library (categories will be handled by the API)
  await promptLibraryService.updatePrompt(promptId, updateData);
  
  // Get updated prompt and return it
  const updatedPrompt = await promptLibraryService.getPromptById(promptId);
  
  return updatedPrompt;
};

/**
 * Update duplicate prompt fields
 * @param {string} duplicateId - The duplicate prompt ID
 * @param {Object} updates - Object with fields to update (title, description, promptText, backgroundTheory, categories)
 * @returns {Promise<Object>} Updated duplicate prompt
 */
export const updateDuplicate = async (duplicateId, updates) => {
  // Prepare update data
  const updateData = {
    ...updates,
    updatedAt: new Date().toISOString(),
  };
  
  // Update duplicate prompt (categories will be handled by the API)
  await promptLibraryService.updateDuplicatePrompt(duplicateId, updateData);
  
  // Get updated duplicate and return it
  const updatedDuplicate = await promptLibraryService.getDuplicatePrompt(duplicateId);
  
  return updatedDuplicate;
};

